let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ePOyH"), load("jkoeR"), load("2Q4bo"), load("1kb22"), load("fwFM0")]).then(() => parcelRequire('eKYmP'));